import { StaffingPostingFormPage } from '@/pages/staffing/StaffingPostingFormPage';
import { getRouteApi, createFileRoute } from '@tanstack/react-router';

const routeApi = getRouteApi('/_authenticated/_app/staffing/postings/$id_/edit');

function StaffingPostingEditRoute() {
	const { id } = routeApi.useParams();
	return <StaffingPostingFormPage postingId={id} />;
}

export const Route = createFileRoute('/_authenticated/_app/staffing/postings/$id_/edit')({
	component: StaffingPostingEditRoute,
});
